import * as Yup from 'yup';

export const contactAddressValidationSchema = Yup.object().shape({
  isCurrent: Yup.boolean().nullable(),
  includeInDti: Yup.boolean().nullable(),
  monthsAtAddress: Yup.number().nullable(),
  unit: Yup.string().nullable().max(128, 'Unit should be max 128 symbols'),
  streetLine1: Yup.string().required('Street is required').max(26, 'Street should be max 26 symbols'),
  streetLine2: Yup.string().nullable(),
  city: Yup.string().max(128, 'City should be max 128 symbols').nullable(),
  state: Yup.string().nullable().required(),
  zip: Yup.string().zipCode().required(),
  type: Yup.string().nullable(),
  county: Yup.string().nullable().max(128, 'County should be max 128 symbols'),
  cdfitm: Yup.boolean().nullable(),
});
